import { ACTION_TYPES } from "./types";
const { SET_USER_COURSES, SET_USER_SERIES_COURSES, SET_COURSE_PURCHASE_BILL } =
  ACTION_TYPES;

export const setUserCourseDetails = (payload) => {
  return (dispatch) => {
    dispatch({
      type: SET_USER_COURSES,
      payload,
    });
  };
};

export const setUserSeriesCourseDetails = (payload) => {
  return (dispatch) => {
    dispatch({
      type: SET_USER_SERIES_COURSES,
      payload,
    });
  };
};

export const setUserCoursePurchaseBill = (payload) => {
  return (dispatch) => {
    dispatch({
      type: SET_COURSE_PURCHASE_BILL,
      payload,
    });
  };
};
